// import "./header.css";

// import { HandySvg } from "handy-svg";
// import iconSrc from "../../../svg/logo.svg";
// import MainPop from "../../popUp/mainPop";
// import { useState } from "react";

// export default function Logo() {
//   const [popUp, setPopUp] = useState(false);
//   const handleMouseEnter = () => {
//     setPopUp(true);
//   };

//   const handleMouseLeave = () => {
//     setPopUp(false);
//   };

//   return (
//     <>
//       <div className="wrapLogo">
//         <HandySvg
//           src={iconSrc}
//           width="129.63"
//           height="120.33"
//           onMouseEnter={handleMouseEnter}
//           onMouseLeave={handleMouseLeave}
//         />
//         <h1 className="logoH1">
//           Видавництво
//           <br />
//           <span>ЧАС МАЙСТРІВ</span>
//         </h1>
//       </div>
//       {popUp && <MainPop />}
//     </>
//   );
// }
import "./header.css";
import { HandySvg } from "handy-svg";
import iconSrc from "../../../svg/logo.svg";
import MainPop from "../../popUp/mainPop";
import { useState } from "react";
import MainPopForH from "../../popUp/mainPopForH";

export default function Logo() {
  const [popUpLogo, setPopUpLogo] = useState(false);
  const [popUpTitle, setPopUpTitle] = useState(false);

  return (
    <>
      <div className="wrapLogo">
        <HandySvg
          src={iconSrc}
          width="129.63"
          height="120.33"
          onMouseEnter={() => setPopUpLogo(true)}
          onMouseLeave={() => setPopUpLogo(false)}
        />
        <h1
          className="logoH1"
          onMouseEnter={() => setPopUpTitle(true)}
          onMouseLeave={() => setPopUpTitle(false)}
        >
          Видавництво
          <br />
          <span>ЧАС МАЙСТРІВ</span>
        </h1>
      </div>

      {popUpLogo && <MainPop />}
      {popUpTitle && <MainPopForH />}
    </>
  );
}
